import { Stack } from '@mui/material';
import apiDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/loyalty-performance-api-defintitions';
import { useTranslation } from 'react-i18next';
import APIDefinitions from 'components/api-definitions/api-definitions.component';

const memberDefinitions = [
  apiDefinitions.newMembersBrandLoyalty,
  apiDefinitions.totalMembersBrandLoyalty,
  apiDefinitions.membersWhoOrdered,
  apiDefinitions.activeMembersBrandLoyalty,
  apiDefinitions.activityRateAllMembers,
  apiDefinitions.activeMemberPercent,
  apiDefinitions.deletedAccountsBrandLoyalty,
];

const loyaltyOrdersDefinitions = [
  apiDefinitions.loyaltyOrdersNetSales,
  apiDefinitions.loyaltyContributionPercentOfSales,
  apiDefinitions.loyaltyContributionPercentOfOrders,
  apiDefinitions.loyaltyAverageCheck,
];

const loyaltyBalancesDefinitions = [
  apiDefinitions.startingBalance,
  apiDefinitions.pointsEarned,
  apiDefinitions.pointsRedeemed,
  apiDefinitions.pointsExpired,
  apiDefinitions.endingBalance,
];

const BrandLoyaltyApiDefinitions = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <APIDefinitions
        type={t(
          'page.loyaltyPerformanceReport.tabs.brandLoyaltyOverview.apiDefinitionsDrawer.membership.label',
        )}
        definitions={memberDefinitions}
      />
      <APIDefinitions
        type={t(
          'page.loyaltyPerformanceReport.tabs.brandLoyaltyOverview.apiDefinitionsDrawer.loyaltyOrders.label',
        )}
        definitions={loyaltyOrdersDefinitions}
      />
      <APIDefinitions
        type={t(
          'page.loyaltyPerformanceReport.tabs.brandLoyaltyOverview.apiDefinitionsDrawer.loyaltyBalances.label',
        )}
        definitions={loyaltyBalancesDefinitions}
      />
    </Stack>
  );
};

export default BrandLoyaltyApiDefinitions;
